import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { AthletesTab } from "../components/AthletesTab";
import { useAuth } from "../contexts/AuthContext";

export default function Athletes() {
	const { user } = useAuth();
	const isAdmin = user?.is_admin || user?.role === "admin";
	const isCoach = user?.role === "coach" || isAdmin;

	if (!isCoach) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<Layout>
			<AthletesTab />
		</Layout>
	);
}
